import { IMAGES } from "./services";

export const CITIES = [
  {
    slug: "boston",
    city: "Boston",
    state: "Massachusetts",
    stateSlug: "massachusetts",
    stateAbbr: "MA",
    image: IMAGES.server_rack,
    imageAlt: "A small Boston business team working on laptops",
    areas: ["Financial District", "Back Bay", "Cambridge", "Seaport", "Somerville", "Quincy"],
    intro:
      "From law firms in the Financial District to consultancies in Cambridge and healthcare practices across Back Bay, Boston runs on small teams doing serious work. As part of our New England home region, Boston clients get the full Sempresera standard with genuine on-site support — 24/7 monitoring, Huntress-powered security, Microsoft 365 management and tested backups, delivered by engineers who can be at your office, not just on the phone.",
    faqs: [
      {
        q: "Do you cover Cambridge, the Seaport and Somerville — or only downtown Boston?",
        a: "The whole metro. Our on-site home region covers the Financial District, Back Bay, Cambridge, the Seaport, Somerville and Quincy alike — if your office is in greater Boston, an engineer can be there in person.",
      },
      {
        q: "Can you help our Boston healthcare practice meet HIPAA expectations?",
        a: "Yes. HIPAA compliance support is part of our cybersecurity service — risk-aware Microsoft 365 configuration, access controls, logging, security awareness training and documentation support aligned with the security rule.",
      },
    ],
    metaTitle: "Managed IT Services in Boston, MA | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered cybersecurity and Microsoft 365 support for Boston small businesses — Financial District to Cambridge. On-site service, one all-inclusive standard.",
  },
  {
    slug: "hartford",
    city: "Hartford",
    state: "Connecticut",
    stateSlug: "connecticut",
    stateAbbr: "CT",
    image: IMAGES.cybersecurity,
    imageAlt: "A Hartford professional at a desk with a computer and phone",
    areas: ["Downtown Hartford", "West Hartford", "Glastonbury", "Manchester", "New Britain", "Wethersfield"],
    intro:
      "Hartford built its name on industries where downtime and data loss are existential — insurance, finance and healthcare. From downtown offices to firms in West Hartford and Glastonbury, Connecticut's capital region gets the full Sempresera standard with on-site support included: one plan, every service, no tiers.",
    faqs: [
      {
        q: "We're in insurance — is data this sensitive really something you handle?",
        a: "It's exactly what we're built for. Sempresera protects confidential-profession firms with least-privilege access, immutable records, and Huntress identity protection watching your Microsoft 365 accounts for credential theft and account takeover.",
      },
      {
        q: "Do your on-site visits reach West Hartford and Glastonbury?",
        a: "Yes. The entire capital region — downtown Hartford, West Hartford, Glastonbury, Manchester, New Britain and Wethersfield — is inside our New England home region, so on-site work is included in the standard plan.",
      },
    ],
    metaTitle: "Managed IT Services in Hartford, CT | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity and 24/7 help desk for Hartford small businesses — Downtown, West Hartford, Glastonbury. On-site service included, one all-inclusive standard.",
  },
  {
    slug: "providence",
    city: "Providence",
    state: "Rhode Island",
    stateSlug: "rhode-island",
    stateAbbr: "RI",
    image: IMAGES.hero_abstract,
    imageAlt: "Professionals working with computers in a small Providence office",
    areas: ["Downtown Providence", "East Side", "Cranston", "Warwick", "Pawtucket", "Newport"],
    intro:
      "Providence punches above its weight — law, design, manufacturing, healthcare and research-driven firms all share a few square miles and the same dependence on systems that just work. Rhode Island's capital gets the full Sempresera standard with on-site support included, because Providence is our home turf.",
    faqs: [
      {
        q: "Our office is on the East Side — is that inside your on-site area?",
        a: "Yes. Providence is home turf: downtown, the East Side and the surrounding towns all get full on-site service, and our Warwick headquarters is minutes away.",
      },
      {
        q: "Can you take over from our current IT provider without disrupting the firm?",
        a: "Yes — switching is a documented, painless process. We inventory your environment, handle the handover with your outgoing provider, and typically complete the transition in two to four weeks with no downtime for your team.",
      },
    ],
    metaTitle: "Managed IT Services in Providence, RI | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered security and Microsoft 365 support for Providence small businesses — Downtown, East Side, Cranston, Warwick. On-site service, one all-inclusive standard.",
  },
  {
    slug: "warwick",
    city: "Warwick",
    state: "Rhode Island",
    stateSlug: "rhode-island",
    stateAbbr: "RI",
    image: IMAGES.office_phone,
    imageAlt: "A Warwick professional getting IT support by phone",
    areas: ["Cowesett", "Apponaug", "Conimicut", "Pawtuxet Village", "West Warwick", "East Greenwich"],
    intro:
      "Warwick is our headquarters city — home to T.F. Green Airport, Rhode Island's retail corridor on Route 2, and thousands of small firms that keep the state running. When your IT provider is literally down the road, on-site support stops being a promise and becomes a short drive. Warwick clients get the full Sempresera standard, delivered by the team that lives here.",
    faqs: [
      {
        q: "You're headquartered in Warwick — how fast can you actually be on site?",
        a: "For Warwick clients, on-site help is a short drive, not a scheduled expedition. Critical issues get a 15-minute remote response target around the clock, and in-person work — planned or emergency — is included in the standard plan.",
      },
      {
        q: "Our office on the Route 2 corridor runs on Microsoft 365 — do you manage that end to end?",
        a: "Yes. Full Exchange, Teams, SharePoint and OneDrive administration, license right-sizing, and Entra ID security policies are all included — plus cloud-to-cloud backup of everything inside your tenant.",
      },
    ],
    metaTitle: "Managed IT Services in Warwick, RI | Sempresera",
    metaDescription:
      "Sempresera's headquarters city. Managed IT, Huntress-powered security and 24/7 help desk for Warwick small businesses — Cowesett to Apponaug. Full on-site service included.",
  },
  {
    slug: "cranston",
    city: "Cranston",
    state: "Rhode Island",
    stateSlug: "rhode-island",
    stateAbbr: "RI",
    image: IMAGES.backup_dr_corporate,
    imageAlt: "Server infrastructure protecting a Cranston small business",
    areas: ["Garden City", "Edgewood", "Knightsville", "Auburn", "Johnston", "Scituate"],
    intro:
      "From the shops and professional offices around Garden City to contractors and practices across Knightsville and Auburn, Cranston runs on small business. Minutes from our Warwick headquarters, Cranston clients get the full Sempresera standard — 24/7 monitoring, Huntress-powered security and tested backups — with on-site support that's genuinely local.",
    faqs: [
      {
        q: "We're a five-person office in Cranston — are we too small for you?",
        a: "You're exactly who we built this for. Sempresera serves solo professionals and firms of up to 25 employees — small business isn't our entry level, it's our entire focus.",
      },
      {
        q: "Do you cover Johnston and Scituate too?",
        a: "Yes. Cranston and its neighboring towns — Johnston, Scituate and the rest of the area — are all inside our Rhode Island home region with full on-site service included.",
      },
    ],
    metaTitle: "Managed IT Services in Cranston, RI | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity and Microsoft 365 support for Cranston small businesses — Garden City, Edgewood, Knightsville. On-site service included, one all-inclusive standard.",
  },
  {
    slug: "pawtucket",
    city: "Pawtucket",
    state: "Rhode Island",
    stateSlug: "rhode-island",
    stateAbbr: "RI",
    image: IMAGES.cybersecurity,
    imageAlt: "A Pawtucket professional working securely at a desk",
    areas: ["Downtown Pawtucket", "Darlington", "Quality Hill", "Central Falls", "Lincoln", "Cumberland"],
    intro:
      "Pawtucket's mill buildings now house manufacturers, makers, studios and professional firms — businesses that blend craft with modern systems. That mix needs IT that respects both. Pawtucket clients get the full Sempresera standard with on-site support included: one plan, every service, delivered by engineers who know the Blackstone Valley.",
    faqs: [
      {
        q: "Our studio is in an old Pawtucket mill building — can you work with the network we've inherited?",
        a: "Yes. Network and firewall management is part of the standard plan, and we assess your setup during onboarding. If the building's wiring is the weak link, we'll tell you plainly and plan around it — no jargon, no surprise projects.",
      },
      {
        q: "Do you also serve Central Falls and Lincoln?",
        a: "Yes. Pawtucket, Central Falls, Lincoln, Cumberland and the wider Blackstone Valley are all inside our New England home region with on-site support included.",
      },
    ],
    metaTitle: "Managed IT Services in Pawtucket, RI | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered security and 24/7 help desk for Pawtucket small businesses — Downtown, Darlington, Central Falls. On-site service, one all-inclusive standard.",
  },
  {
    slug: "worcester",
    city: "Worcester",
    state: "Massachusetts",
    stateSlug: "massachusetts",
    stateAbbr: "MA",
    image: IMAGES.managed_it_corporate,
    imageAlt: "An IT engineer monitoring systems for a Worcester business",
    areas: ["Downtown Worcester", "Shrewsbury Street", "West Side", "Auburn", "Shrewsbury", "Millbury"],
    intro:
      "New England's second city runs on healthcare, education, manufacturing and the professional firms that support them. Worcester's small businesses carry real compliance and uptime obligations — without enterprise budgets. As part of our New England home region, Worcester clients get the full Sempresera standard with genuine on-site support, not a remote shrug.",
    faqs: [
      {
        q: "Is Worcester really inside your on-site region, being based in Rhode Island?",
        a: "Yes. Our New England home region covers central Massachusetts, so Worcester clients get the same full service as firms ten minutes from our office — on-site visits included, never billed as an extra.",
      },
      {
        q: "Can you support a Worcester practice with compliance obligations?",
        a: "Yes. We support HIPAA compliance programs for small practices — hardened Microsoft 365 configuration, access controls, logging, awareness training and documentation support — backed by a 24/7 human-led security operations center.",
      },
    ],
    metaTitle: "Managed IT Services in Worcester, MA | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered cybersecurity and Microsoft 365 support for Worcester small businesses — Downtown, Shrewsbury Street, Auburn. On-site service, one all-inclusive standard.",
  },
  {
    slug: "springfield",
    city: "Springfield",
    state: "Massachusetts",
    stateSlug: "massachusetts",
    stateAbbr: "MA",
    image: IMAGES.server_rack,
    imageAlt: "A Springfield small business team working on laptops",
    areas: ["Downtown Springfield", "Forest Park", "Sixteen Acres", "West Springfield", "Chicopee", "Longmeadow"],
    intro:
      "The Pioneer Valley's professional firms, healthcare practices and manufacturers deserve the same caliber of IT as Boston — without Boston rates or Boston indifference. Springfield is part of our New England home region, so the full Sempresera standard includes real on-site support: monitoring that never sleeps, security run by humans, and a help desk that answers.",
    faqs: [
      {
        q: "Do you actually serve the Pioneer Valley, or just the Boston area?",
        a: "We serve it properly. Springfield, Chicopee, Longmeadow, West Springfield and the rest of the valley are inside our New England home region — full service with on-site support included.",
      },
      {
        q: "What happens if something breaks at our Springfield office after hours?",
        a: "The same thing that happens at 2pm: a person answers. Our help desk is staffed 24/7/365 with a 15-minute response target for critical issues, and every client has their assigned engineer's direct cell.",
      },
    ],
    metaTitle: "Managed IT Services in Springfield, MA | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity and 24/7 help desk for Springfield small businesses — Downtown, Forest Park, Chicopee, Longmeadow. On-site service, one all-inclusive standard.",
  },
  {
    slug: "new-haven",
    city: "New Haven",
    state: "Connecticut",
    stateSlug: "connecticut",
    stateAbbr: "CT",
    image: IMAGES.office_team,
    imageAlt: "A New Haven small business team collaborating around a laptop",
    areas: ["Downtown New Haven", "East Rock", "Westville", "Hamden", "West Haven", "Orange"],
    intro:
      "New Haven's economy runs on knowledge — law firms, medical practices, research spin-offs and the consultants who serve them. Work like that leaves no room for lost files or compromised mailboxes. New Haven clients get the full Sempresera standard with on-site support included: one plan, every service, no tiers.",
    faqs: [
      {
        q: "We're a law firm in downtown New Haven — how do you protect client confidentiality?",
        a: "With least-privilege access, hardened Microsoft 365 policies, Huntress identity protection against credential theft, and immutable backups that keep records recoverable even in a worst-case scenario.",
      },
      {
        q: "Can you migrate our firm off an aging email system onto Microsoft 365?",
        a: "Yes. Migrations are part of the standard service — email, files and calendars moved with a cutover plan that keeps your team working, whether you're coming from on-premises Exchange, Google Workspace or a legacy server.",
      },
    ],
    metaTitle: "Managed IT Services in New Haven, CT | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered security and Microsoft 365 support for New Haven small businesses — Downtown, East Rock, Hamden. On-site service, one all-inclusive standard.",
  },
  {
    slug: "stamford",
    city: "Stamford",
    state: "Connecticut",
    stateSlug: "connecticut",
    stateAbbr: "CT",
    image: IMAGES.hero_abstract,
    imageAlt: "Professionals working late in a Stamford office",
    areas: ["Downtown Stamford", "Harbor Point", "Springdale", "Glenbrook", "Greenwich", "Darien"],
    intro:
      "Stamford plays in the big leagues — financial firms, agencies and professional practices with New York expectations and small-business headcounts. That combination demands enterprise-grade IT without enterprise overhead. Stamford clients get the full Sempresera standard: 24/7 monitoring, Huntress-powered security and a help desk that answers, with on-site support included.",
    faqs: [
      {
        q: "Our Stamford firm works at a New York pace — can you keep up?",
        a: "Yes. Critical issues carry a 15-minute response target any hour of any day, support hours are unlimited and never capped, and you escalate to senior engineers — not a script.",
      },
      {
        q: "Do you cover offices in Greenwich and Darien as well?",
        a: "Yes. Stamford, Greenwich, Darien and the rest of lower Fairfield County are inside our New England home region, with on-site support included in the standard plan.",
      },
    ],
    metaTitle: "Managed IT Services in Stamford, CT | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity and Microsoft 365 support for Stamford small businesses — Downtown, Harbor Point, Glenbrook. On-site service, one all-inclusive standard.",
  },
  {
    slug: "manchester",
    city: "Manchester",
    state: "New Hampshire",
    stateSlug: "new-hampshire",
    stateAbbr: "NH",
    image: IMAGES.managed_it_corporate,
    imageAlt: "An engineer keeping servers healthy for a Manchester business",
    areas: ["Downtown Manchester", "Millyard", "North End", "Bedford", "Hooksett", "Londonderry"],
    intro:
      "From the reinvented Millyard to firms along the Everett Turnpike corridor, Manchester is New Hampshire's business engine — and its small companies expect straight answers and systems that work. Manchester clients get the full Sempresera standard with on-site support included: no tiers, no upsells, no fine print.",
    faqs: [
      {
        q: "We're a tech-focused company in the Millyard — do you work with businesses like ours?",
        a: "Yes. We support small firms of every kind up to 25 employees — including technology companies that want their own environment monitored, patched and secured to the same standard they hold for their clients.",
      },
      {
        q: "Is on-site support really included for New Hampshire?",
        a: "It is. New Hampshire is part of our New England home region, so Manchester-area clients get on-site visits for projects, planned work and emergencies as part of the plan — not as an add-on.",
      },
    ],
    metaTitle: "Managed IT Services in Manchester, NH | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered security and 24/7 help desk for Manchester small businesses — Millyard, Downtown, Bedford, Hooksett. On-site service, one all-inclusive standard.",
  },
  {
    slug: "burlington",
    city: "Burlington",
    state: "Vermont",
    stateSlug: "vermont",
    stateAbbr: "VT",
    image: IMAGES.backup_dr_corporate,
    imageAlt: "Secure backup infrastructure for a Burlington business",
    areas: ["Downtown Burlington", "Old North End", "South End", "Essex Junction", "South Burlington", "Winooski"],
    intro:
      "Burlington punches above its size — a lakefront city of practices, agencies, makers and mission-driven firms that depend on their systems as much as any big-metro business. Providers who only chase large markets overlook places like this; we built Sempresera for exactly the opposite. Burlington clients get the full standard with real on-site support, because Vermont is New England too.",
    faqs: [
      {
        q: "Most IT companies overlook Vermont — why don't you?",
        a: "Because small businesses here deserve the same standard as anywhere. Sempresera was built exclusively for small firms, and Vermont is part of our New England home region — Burlington clients get full service with on-site support included.",
      },
      {
        q: "What happens to our Burlington office's data if ransomware hits?",
        a: "Your backups are immutable — written with object lock so even an attacker inside your network can't alter or delete them. We test restores quarterly and run a full disaster recovery drill annually, so recovery is proven, not hoped for.",
      },
    ],
    metaTitle: "Managed IT Services in Burlington, VT | Sempresera",
    metaDescription:
      "Managed IT, cybersecurity and Microsoft 365 support for Burlington small businesses — Downtown, South End, Essex Junction, Winooski. On-site service, one all-inclusive standard.",
  },
  {
    slug: "portland",
    city: "Portland",
    state: "Maine",
    stateSlug: "maine",
    stateAbbr: "ME",
    image: IMAGES.cybersecurity,
    imageAlt: "A Portland professional working securely at a computer",
    areas: ["Old Port", "Downtown Portland", "East Bayside", "Deering", "South Portland", "Westbrook"],
    intro:
      "From the Old Port's firms to practices across the peninsula, Portland's small businesses are the city's backbone — and they can't afford a bad IT day any more than a Boston firm can. Portland clients get the full Sempresera standard with on-site support included as part of our New England home region: one plan, every service, delivered by people who understand Maine distances.",
    faqs: [
      {
        q: "We're in the Old Port — is Portland really inside your service area?",
        a: "Yes. Portland and its neighbors — South Portland, Westbrook and the surrounding towns — are part of our New England home region, with on-site support included in the standard plan.",
      },
      {
        q: "If our office internet or phones go down, do we call you or the provider?",
        a: "Call us. Vendor management is part of the standard service — we deal with your internet and phone providers, coordinate repairs and stay on it until you're back up, so you never sit in a carrier's hold queue.",
      },
    ],
    metaTitle: "Managed IT Services in Portland, ME | Sempresera",
    metaDescription:
      "Managed IT, Huntress-powered security and 24/7 help desk for Portland small businesses — Old Port, Downtown, East Bayside, South Portland. On-site service, one all-inclusive standard.",
  },
];
